import { updateSearchParamsQs, useMetaData } from '@websolutespa/bom-mixer-hooks';
import Head from 'next/head';

export function RelPrevNext({
  page,
  nextPage,
  prevPage,
  formatTitle = (page:number, title:string) => `${title} - ${page}`,
}: {
  page: number;
  nextPage: number | undefined;
  prevPage: number | undefined;
  formatTitle?: (page:number, title:string) => string;
}) {
  const metaData = useMetaData();
  const title = formatTitle(page, metaData.meta.title);
  let relPrev: string | undefined;
  let relNext: string | undefined;
  if (prevPage) {
    const { pathname, query } = updateSearchParamsQs(metaData.meta.url,
      {
        pagination: { page: page - 1 },
      }
    );
    relPrev = `${pathname}?${query}`;
  }
  if (nextPage) {
    const { pathname, query } = updateSearchParamsQs(metaData.meta.url,
      {
        pagination: { page: nextPage },
      }
    );
    relNext = `${pathname}?${query}`;
  }
  return (
    <Head>
      <title>{title}</title>
      {relPrev && (
        <link rel="prev" href={relPrev} />
      )}
      {relNext && (
        <link rel="next" href={relNext} />
      )}
    </Head>
  );
}
